// extracted by mini-css-extract-plugin
module.exports = {"dropbox":"styles_dropbox__NJB4p","verticalLine":"styles_verticalLine__EjaeN"};